import { createApiInstance } from '../../foundation/api';
import Storage from '../../features/helpers/storageHelper';
import cmsApi from '../../features/endPoints/cmsEndpoints';

const cmsClient = createApiInstance(process.env.REACT_APP_CMS_URL, false, {
  timeout: JSON.parse(process.env.REACT_APP_ECOMM_TIMEOUT_SEC || 0) * 1000,
});

var _tempStorage = {};

const LocalBranchClient = (zipcode, tempOnly, isCheckout) => { 

  return cmsClient.get(
    cmsApi.localBranch(zipcode),
    '',
    isCheckout ? mapCheckoutResponse : mapResponse(zipcode, tempOnly),
    mapError
  );
};

const LocalBranchInfoClient = (zipcode) => {  
  return cmsClient.get(
    cmsApi.localBranch(zipcode),
    '',
    mapResponseInfo
  );
};

LocalBranchClient.updateStorage = () => {
  let zipcode = _tempStorage.zipcode;
  let branch = mapResponseInfo(_tempStorage.response);

  Storage.branchPref({ zipcode, ...branch });
  // window.utagTrackInteraction('update location zip code');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
  'event': 'interaction',
  'category': 'User Navigation',
  'action': 'click',
  'label': 'update location zip code'
  });
};

const mapCheckoutResponse = (response) => {
  if(!response.data || response.data.data.length === 0) {
    return '';
  }
  if(response.data.data[0] && response.data.data[0].branchData[0]){
    const branchId = response.data.data[0].branchData[0].branchNumber;
    if(isNaN(parseInt(branchId))) return '';

    let branchType = response.data.data[0].branchData[0].branchType;
    if(branchType === null || branchType === undefined) {
      return 'branch';
    } else {
      return branchType;
    }
  }
  return '';
};

//map response to object needed by React view
const mapResponse = (zipcode, tempOnly) => (response) => {
  _tempStorage = { zipcode, response };
  if(!tempOnly) {
    LocalBranchClient.updateStorage();
  }
  return response;
};

const mapResponseInfo = (response) => {
  if(!response.data || response.data.data.length === 0) {
    return {};
  }

  let branchDetails = response.data.data[0];
  let branchId = branchDetails.branchData[0].branchNumber;
  let stateId = branchDetails.regionCode;
  let city = branchDetails.branchData[0].branchAddressLineCity;
  let branchName = branchDetails.postalCity;

  return {
    branchId,
    stateId,
    branchName,
    city
  };
};

//map error to object needed by React view
const mapError = (error) => {
  error.customErrorCode = 'checkoutApiError';
  error.reason = 'BranchNotFound';
  return error;
};

export default LocalBranchClient;
export { LocalBranchInfoClient };